import { Seo } from "../components/site/Seo";
import { CTAButton } from "../components/site/CTAButton";

export default function NotFoundPage() {
  return (
    <section className="bg-[#F9F8F3] px-5 pt-40 pb-32 md:px-10" data-testid="not-found">
      <Seo title="Page not found" path="/404" description="The page you are looking for could not be found." />
      <div className="mx-auto max-w-[1440px]">
        <p className="font-display text-7xl font-bold text-[#082619]">404</p>
        <p className="mt-4 text-lg text-[#4C6053]">This page could not be found.</p>
        <div className="mt-8"><CTAButton to="/" variant="forest" testId="notfound-home">Back to Home</CTAButton></div>
      </div>
    </section>
  );
}
